import { render, staticRenderFns } from "./OrderConfirmation.vue?vue&type=template&id=c71754e0&"
import script from "./OrderConfirmation.vue?vue&type=script&lang=ts&"
export * from "./OrderConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports